import { Dialog } from "components/ui/Dialog";
import { SearchInput } from "components/ui/SearchInput";

import s from "./InsertPickerModal.module.css";

/*
 * Always opened from inside another modal — a letter, a sick cert, an email — so it
 * stacks above Dialog's default 1300. At the shared level its backdrop landed under the
 * dialog beneath it, which left that one at full brightness and made the picker read as
 * a panel pasted into the middle of the form rather than a layer over it.
 */
const PICKER_Z_INDEX = 1400;

export const InsertPickerModal = ({
  isOpen,
  onClose,
  title,
  search,
  onSearchChange,
  searchPlaceholder,
  isLoading,
  loadingText = "Loading...",
  emptyText = "No items found",
  items,
  renderItem,
  onSelect,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={title}
      width={700}
      zIndex={PICKER_Z_INDEX}
    >
      <div className={s.search}>
        <SearchInput
          value={search}
          onChange={onSearchChange}
          placeholder={searchPlaceholder}
          variant="bordered"
        />
      </div>
      <div className={s.list}>
        {isLoading ? (
          <p className={s.loading}>{loadingText}</p>
        ) : items.length > 0 ? (
          items.map((item) => (
            <div
              key={item.id}
              className={s.item}
              onClick={() => onSelect(item)}
            >
              {renderItem(item)}
            </div>
          ))
        ) : (
          <p className={s.empty}>{emptyText}</p>
        )}
      </div>
    </Dialog>
  );
};
